import React from 'react';

import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { cn } from '@/utils';

interface HeaderMenuDrawerSingleProps extends ButtonProps {
  Icon: React.FC<{ className?: string }>;
  href?: string;
  navigateTo?: string;
}

const HeaderMenuDrawerSingle: React.FC<HeaderMenuDrawerSingleProps> = ({
  href,
  Icon,
  children,
  className,
  ...buttonProps
}) => {
  const buttonStyles = cn(
    'flex w-full cursor-pointer items-center justify-start gap-4 rounded-xl py-6 text-base',
    className
  );

  if (href) {
    return (
      <Button asChild className={buttonStyles} variant="secondary" {...buttonProps}>
        <a href={href} rel="noopener noreferrer" target="_blank">
          <Icon className="size-5 shrink-0" />
          {children}
        </a>
      </Button>
    );
  }

  return (
    <Button className={buttonStyles} variant="secondary" {...buttonProps} asChild>
      <div>
        <Icon className="size-5 shrink-0" />
        {children}
      </div>
    </Button>
  );
};

export default HeaderMenuDrawerSingle;
